import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { SmtpConfig } from '../model/smtp-config';

@Injectable({
    providedIn: 'root'
  })
  export class SmtpConfigService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllSmtps() 
    {
        return this._restClientService.load<SmtpConfig[]>('smtp-config/get');
    }
    
    getSmtpById(smtpId){
        return this._restClientService.load<SmtpConfig>('smtp-config/get/'+smtpId);
    }
    
    putSmtp(smtpConfig: SmtpConfig) {
        return  this._restClientService.put<SmtpConfig>(`smtp-config/update`, smtpConfig);
    }
    
    postSmtp(smtpConfig: SmtpConfig) {
        return  this._restClientService.save<SmtpConfig>(`smtp-config/add`, smtpConfig);
    }
    
    deleteSmtp(smtpId) 
    {
        return this._restClientService.delete<any>('smtp-config/delete/'+smtpId);
    }
  
}      

    